import * as React from 'react';
import {classNames, variationName} from '@shopify/react-utilities/styles';
import {Button, Text, VerticalRhythm} from 'components/UIKit';
import {BackgroundColors} from 'components/UIKit/Types';
import styles from './ContentBlock.scss';

export interface ContentBlockProps {
  heading: string;
  subhead?: string;
  cta?: string;
  url?: string;
  copy?: React.ReactNode;
  theme?: BackgroundColors;
}

export function ContentBlock(props: ContentBlockProps) {
  const {heading, subhead, cta, url, copy, theme = 'white'} = props;

  return (
    <VerticalRhythm paddingTop="xl" paddingBottom="xl" backgroundColor={theme} constrained>
      <div className={styles.content}>
        <div className={styles.headingGroup}>
          <Text
            className={classNames(styles.heading, styles[variationName('theme', theme)])}
            text={heading}
            type="h2"
            inheritColor
          />
          {subhead && <Text text={subhead} type="regular" component="p" inheritColor secondary={theme === 'white'} />}
          {cta && <Button label={cta} url={url} />}
        </div>
        {copy && <Text type="regular" component="p" inheritColor className={styles.copy} text={copy} />}
      </div>
    </VerticalRhythm>
  );
}
